import { ConfigReportComboApi } from "go-report-combo/User/services/types";

export const REPORT_onboarding_person_kpi = {
	id: "REPORT_onboarding_person_kpi",
	name: "KPI Onboarding - person",
	data: [
		{
			id: "TRANSACTION_PAID",
			resource: "TRANSACTION",
			filter: "product_partner_type|e=CSVçtransaction_type_quantity|e=UPGRADE¥DOWNGRADEçname|e=ADDON_PHONE_CENTRAL¥DRIVERS¥EMENU¥GOCRM¥GOHUB¥GOORDER¥GOPOS_KDS¥GOPOS_KIOSK¥GOPOS_NUMBER_DISPLAY¥GOSTOCK_IMPORT¥GOSTOCK_INVENTORY_APP¥GOSTOCK_TRANSFER",
			groups: ["NONE", "PRODUCT_PARTNER"],
			columns: [
				{
					id: "summary",
					filter: "paid_at|bt={date_range__QUARTER}",
				},
				{
					id: "monthly",
					group: "PAID_AT_MONTH",
					filter: "paid_at|bt={date_range__QUARTER}",
				},
			],
		},
		{
			id: "TRANSACTION_PAYMENT_DUE",
			resource: "TRANSACTION",
			filter: "product_partner_type|e=CSVçtransaction_type_quantity|e=UPGRADE¥DOWNGRADEçstatus|e=PAYMENT_DUEçname|e=ADDON_PHONE_CENTRAL¥DRIVERS¥EMENU¥GOCRM¥GOHUB¥GOORDER¥GOPOS_KDS¥GOPOS_KIOSK¥GOPOS_NUMBER_DISPLAY¥GOSTOCK_IMPORT¥GOSTOCK_INVENTORY_APP¥GOSTOCK_TRANSFER",
			groups: ["NONE", "PRODUCT_PARTNER"],
			columns: [
				{
					id: "summary",
					filter: "date|bt={date_range__QUARTER}",
				},
				{
					id: "monthly",
					group: "DATE_MONTH",
					filter: "date|bt={date_range__QUARTER}",
				},
			],
		},
	],
	table: [
		{
			id: "products_progress",
			name: "Produkty - w trakcie płatności",
			rows: [
				{
					id: "TRANSACTION_PAYMENT_DUE",
					name: "TRANSACTION_PAYMENT_DUE",
					data_id: "TRANSACTION_PAYMENT_DUE",
					group: "ORGANIZATION_PARTNER_CS",
					aggregate: "upgrade_quantity",
					compare: [
						{
							id: "upgrade",
							data_id: "TRANSACTION_PAYMENT_DUE",
							name: "Upgrade",
							format: "VALUE",
							aggregate: "upgrade_quantity",
						},
						{
							id: "downgrade",
							data_id: "TRANSACTION_PAYMENT_DUE",
							name: "Downgrade",
							format: "VALUE",
							aggregate: "downgrade_quantity",
						},
					],
				},
			],
			columns: [
				{
					id: "upgrade_quantity",
					data_column_id: "summary",
					name: "Produkty",
				},
				{
					id: "upgrade_quantity_monthly",
					data_column_id: "monthly",
					name: "Produkty",
					values_dynamic: "values_previous_12_months",
				},
			],
		},
		{
			id: "products_paid",
			name: "Produkty - opłacone",
			rows: [
				{
					id: "products",
					name: "products",
					data_id: "TRANSACTION_PAID",
					group: "ORGANIZATION_PARTNER_CS",
					aggregate: "upselling_quantity",
					compare: [
						{
							id: "upgrade",
							data_id: "TRANSACTION_PAID",
							name: "Upgrade",
							format: "VALUE",
							aggregate: "upgrade_quantity",
						},
						{
							id: "downgrade",
							data_id: "TRANSACTION_PAID",
							name: "Downgrade",
							format: "VALUE",
							aggregate: "downgrade_quantity",
						},
					],
				},
			],
			columns: [
				{
					id: "upgrade_quantity",
					data_column_id: "summary",
					name: "Produkty",
				},
				{
					id: "upgrade_quantity_monthly",
					data_column_id: "monthly",
					name: "Produkty",
					values_dynamic: "values_previous_12_months",
				},
			],
		},
		{
			id: "points_progress",
			name: "Punkty - w trakcie płatności",
			rows: [
				{
					id: "points_progress",
					name: "points_progress",
					data_id: "TRANSACTION_PAYMENT_DUE",
					group: "ORGANIZATION_PARTNER_CS",
					aggregate: "upgrade_points",
					compare: [
						{
							id: "upgrade",
							data_id: "TRANSACTION_PAYMENT_DUE",
							name: "Upgrade",
							format: "VALUE",
							aggregate: "upgrade_points",
						},
						{
							id: "downgrade",
							data_id: "TRANSACTION_PAYMENT_DUE",
							name: "Downgrade",
							format: "VALUE",
							aggregate: "downgrade_points",
						},
					],
				},
			],
			columns: [
				{
					id: "upgrade_quantity",
					data_column_id: "summary",
					name: "Produkty",
				},
				{
					id: "upgrade_quantity_monthly",
					data_column_id: "monthly",
					name: "Produkty",
					values_dynamic: "values_previous_12_months",
				},
			],
		},
		{
			id: "points_paid",
			name: "Punkty - opłacone",
			rows: [
				{
					id: "points",
					name: "points",
					data_id: "TRANSACTION_PAID",
					group: "ORGANIZATION_PARTNER_CS",
					aggregate: "upselling_points",
					compare: [
						{
							id: "upgrade",
							data_id: "TRANSACTION_PAID",
							name: "Upgrade",
							format: "VALUE",
							aggregate: "upgrade_points",
						},
						{
							id: "downgrade",
							data_id: "TRANSACTION_PAID",
							name: "Downgrade",
							format: "VALUE",
							aggregate: "downgrade_points",
						},
					],
				},
			],
			columns: [
				{
					id: "upgrade_quantity",
					data_column_id: "summary",
					name: "Produkty",
				},
				{
					id: "upgrade_quantity_monthly",
					data_column_id: "monthly",
					name: "Produkty",
					values_dynamic: "values_previous_12_months",
				},
			],
		},
	],
} as ConfigReportComboApi;
